import type {Writable} from 'svelte/store';
import {writable} from 'svelte/store';
import {Subject} from 'rxjs';
import {getContext, setContext} from 'svelte';

export interface ValueEditorLabelContext {
    editorId: string;
    labelId: string;
    clickEvent$: Subject<void>;
    config: Writable<LabelConfiguration>;
    labelText?: string;
}

export interface LabelConfiguration {
    disableRequiredAsterisk: boolean;
    disableForAttribute: boolean;
}

export const DEFAULT_LABEL_CONFIG = Object.freeze<LabelConfiguration>({
    disableForAttribute: false,
    disableRequiredAsterisk: false
});

export function createValueEditorsLabelContext(editorId: string, labelText?: string): ValueEditorLabelContext {
    const labelId = `${editorId}-label`;
    const labelClickEvent$: Subject<void> = new Subject();
    const labelConfig = writable<LabelConfiguration>({...DEFAULT_LABEL_CONFIG});
    return {editorId, labelId, config: labelConfig, clickEvent$: labelClickEvent$, labelText};
}

export function setValueEditorLabelContext(labelContext: ValueEditorLabelContext | null): void {
    setContext(LABEL_CONTEXT_KEY, labelContext);
}

export function getValueEditorLabelContext(): ValueEditorLabelContext | null {
    return getContext(LABEL_CONTEXT_KEY);
}

export const LABEL_CONTEXT_KEY = 'LABEL_CONTEXT_KEY';
